"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault")["default"];

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard")["default"];

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _functionalButton = require("@widget/functional-button");

var _app = require("@package/app");

var _utils = require("@package/utils");

var _storybook = require("@pikassa/storybook");

var _hoc = require("@package/hoc");

var _react = _interopRequireWildcard(require("react"));

var _reactRedux = require("react-redux");

var _Form = _interopRequireDefault(require("./Form"));

var _useGetAvailableBuyAccount = _interopRequireDefault(require("./hooks/useGetAvailableBuyAccount"));

var _useGetAvailableSellAccount = _interopRequireDefault(require("./hooks/useGetAvailableSellAccount"));

var _defaultModule = _interopRequireDefault(require("./default.module.scss"));

function useGetAvailableShops(shops) {
  return (0, _react.useMemo)(function () {
    var shopsWithAccounts = shops.filter(function (shop) {
      return !!Object.keys(shop['accounts']).length && shop['additionalSettings']['allowExchange'];
    });
    return shopsWithAccounts.filter(function (shop) {
      for (var key in shop['accounts']) {
        if (shop['accounts'].hasOwnProperty(key)) {
          var account = shop['accounts'][key];

          if (account['available'] > 0) {
            return true;
          }
        }
      }

      return false;
    });
  }, [shops]);
}

function useGetDefaultShop(shops) {
  return (0, _react.useMemo)(function () {
    return !!shops.length ? shops[0] : null;
  }, [shops]);
}

function useGetDefaultAccount(accounts) {
  return (0, _react.useMemo)(function () {
    return !!accounts.length ? accounts[0]['id'] : null;
  }, [accounts]);
}

function HOC() {
  try {
    var handleSubmit = function handleSubmit(data) {
      dispatch((0, _functionalButton.createExchange)(data));
    };

    var dispatch = (0, _reactRedux.useDispatch)();
    var shops = (0, _reactRedux.useSelector)(_functionalButton.selectShops);
    var inProcess = (0, _reactRedux.useSelector)(_functionalButton.selectInProcess);
    var availableShops = useGetAvailableShops(shops);
    var defaultShop = useGetDefaultShop(availableShops);
    var availableSellAccounts = (0, _useGetAvailableSellAccount["default"])(defaultShop);
    var defaultSellAccount = useGetDefaultAccount(availableSellAccounts);
    var availableBuyAccounts = (0, _useGetAvailableBuyAccount["default"])(defaultSellAccount);
    var defaultBuyAccount = useGetDefaultAccount(availableBuyAccounts);
    (0, _hoc.useMount)(function () {
      dispatch((0, _functionalButton.getShopsV2)({
        status: 'Active',
        include: ['additionalSettings', 'accounts']
      }));
    });
    (0, _hoc.useUnmount)(function () {
      dispatch((0, _functionalButton.resetStateAction)());
    });

    if (inProcess) {
      return /*#__PURE__*/_react["default"].createElement("div", {
        className: _defaultModule["default"]['spinner']
      }, /*#__PURE__*/_react["default"].createElement(_storybook.Spinner, null));
    }

    return /*#__PURE__*/_react["default"].createElement(_Form["default"], {
      onSubmit: function onSubmit(data) {
        return handleSubmit(data);
      },
      shops: availableShops,
      initialValues: {
        externalId: (0, _utils.uuid)(),
        shop: defaultShop,
        sign: null,
        date: null,
        'buy-amount': '',
        'sell-amount': '',
        'buy-currency': defaultBuyAccount,
        'sell-currency': defaultSellAccount
      }
    });
  } catch (e) {
    return /*#__PURE__*/_react["default"].createElement(_app.Error, {
      error: e
    });
  }
}

var _default = HOC;
exports["default"] = _default;